import { Pipe, PipeTransform } from '@angular/core';


@Pipe( { name: 'localeSorter' })
export class LocaleSorterPipe<T> implements PipeTransform {
    transform( list: any[] ): T[] {

        var localeOrder = ['en', 'zh_TW', 'zh_CN'];

        for ( let ele of list ) {
            for ( var i = 0; i < localeOrder.length; i++ ) {
                if ( ele.locale === localeOrder[i] ) {
                    ele._localeSeq = i;
                }
            }
        }
        return list.sort( function( a, b ) { return ( a._localeSeq > b._localeSeq ) ? 1 : ( ( b._localeSeq > a._localeSeq ) ? -1 : 0 ); });
    }
}
